function MenuImages({ path, imagecount }) {
  const renderImages = () => {
    // Check if imagecount is a valid number
    if (imagecount <= 0) {
      return <p>No images available.</p>;
    }
    const images = [];
    for (let i = 0; i < imagecount; i++) {
      images.push(
        <img key={i} src={`${path}/${i + 1}.webp`} alt={`${i + 1}`} className="w-100"/>
      );
    }
    return images;
  };
  return (
    <>
       {renderImages()}
    </>
  );
}

export default MenuImages;
